import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";
import { List, Map } from "immutable";
import numeral from "numeral";
import moment from 'moment';
import Auth from '../../../lib/auth';

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";
import Select from "../../../components/common/virtualized-select";
import Loading from '../../../components/common/Loading';

// Actions
import { getYears, cleanYears } from '../../../actions/years';
import { getSalesOrders, changeSalesOrderStatus, cleanSalesOrders } from "../../../actions/sales-orders";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

const queryOptions = {
    projection: 'order_code document_date expected_delivery_date customer statistics.subtotal statistics.vat statistics.total status',
    populateRefs: [{
        field: 'customer',
        projection: 'basic_info.name'
    }],
    calculateStatistics: 'sales-orders',
    deleteVirtuals: true
};

class SalesOrdersPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            salesOrderFilters: '',
            selectedYear: Auth.getSelectedYear(),
            salesOrdersIsFetching: false
        };
    }
    componentDidMount() {
        this.props.getYears();
        this.updateQueryOptions(this.state.selectedYear);
        this.props.getSalesOrders(queryOptions);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.selectedYear !== prevState.selectedYear) {
            this.updateQueryOptions(this.state.selectedYear);
            this.props.getSalesOrders(queryOptions);
        }
    }
    componentWillUnmount() {
        this.props.cleanSalesOrders();
        this.props.cleanYears();
    }

    updateQueryOptions = (selectedYear) => {
        queryOptions.filters = {
            document_date: {
                $gte: new Date(moment(selectedYear, "YYYY").startOf("year")),
                $lt: new Date(moment(selectedYear, "YYYY").endOf("year"))
            }
        };
    };

    onChangeYear = (year) => {
        this.setState({
            selectedYear: year
        });

        Auth.setSelectedYear(year);
    };

    render() {
        const yearOptions = this.props.years || List([Map({ year: moment().year })]);

        let tableData = this.props.salesOrders;
        const salesOrdersIsFetching = this.props.salesOrdersIsFetching;

        // Filters Zone
        let totalOrders = 0;
        this.props.salesOrders.forEach(order => totalOrders = totalOrders + order.getIn(['statistics', 'total']));
        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label ">{ numeral(totalOrders).format() }</span>
                    <span>Importe Total</span>
                </div>
                <div className="col-auto">
                    <span className="label "><strong>{ this.props.salesOrders.size || 0 }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ salesOrderFilters: '' }) }><strong>Pedidos</strong></span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ this.props.salesOrders.count(order => order.get('status') === 'sent') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ salesOrderFilters: 'sent' }) }>Enviados</span>
                </div>
                <div className="col-auto">
                    <span className="label label-warning">{ this.props.salesOrders.count(order => order.get('status') === 'in_progress') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ salesOrderFilters: 'in_progress' }) }>En proceso</span>
                </div>
                <div className="col-auto">
                    <span className="label label-warning-light">{ this.props.salesOrders.count(order => order.get('status') === 'partial') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ salesOrderFilters: 'partial' }) }>Parciales</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ this.props.salesOrders.count(order => order.get('status') === 'pending') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ salesOrderFilters: 'pending' }) }>Pendientes</span>
                </div>
            </div>
        );

        switch (this.state.salesOrderFilters) {
            case 'sent':
                statsZone = (
                    <div className="row stats-zone" style={{marginBottom: 20}}>
                        <div className="col-auto">
                            <span className="label ">{numeral(totalOrders).format()}</span>
                            <span>Importe Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{this.props.salesOrders.size || 0}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: ''})}>Pedidos</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-primary"><strong>{this.props.salesOrders.count(order => order.get('status') === 'sent')}</strong></span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'sent'})}><strong>Enviados</strong></span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning">{this.props.salesOrders.count(order => order.get('status') === 'in_progress')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'in_progress'})}>En proceso</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning-light">{this.props.salesOrders.count(order => order.get('status') === 'partial')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'partial'})}>Parciales</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-danger">{this.props.salesOrders.count(order => order.get('status') === 'pending')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'pending'})}>Pendientes</span>
                        </div>
                    </div>
                );
                tableData = this.props.salesOrders.filter(salesOrder => salesOrder.get('status') === 'sent');
                break;
            case 'in_progress':
                statsZone = (
                    <div className="row stats-zone" style={{marginBottom: 20}}>
                        <div className="col-auto">
                            <span className="label ">{numeral(totalOrders).format()}</span>
                            <span>Importe Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{this.props.salesOrders.size || 0}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: ''})}>Pedidos</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-primary">{this.props.salesOrders.count(order => order.get('status') === 'sent')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'sent'})}>Enviados</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning"><strong>{this.props.salesOrders.count(order => order.get('status') === 'in_progress')}</strong></span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'in_progress'})}><strong>En proceso</strong></span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning-light">{this.props.salesOrders.count(order => order.get('status') === 'partial')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'partial'})}>Parciales</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-danger">{this.props.salesOrders.count(order => order.get('status') === 'pending')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'pending'})}>Pendientes</span>
                        </div>
                    </div>
                );
                tableData = this.props.salesOrders.filter(salesOrder => salesOrder.get('status') === 'in_progress');
                break;
            case 'partial':
                statsZone = (
                    <div className="row stats-zone" style={{marginBottom: 20}}>
                        <div className="col-auto">
                            <span className="label ">{numeral(totalOrders).format()}</span>
                            <span>Importe Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{this.props.salesOrders.size || 0}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: ''})}>Pedidos</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-primary">{this.props.salesOrders.count(order => order.get('status') === 'sent')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'sent'})}>Enviados</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning">{this.props.salesOrders.count(order => order.get('status') === 'in_progress')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'in_progress'})}>En proceso</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning-light"><strong>{this.props.salesOrders.count(order => order.get('status') === 'partial')}</strong></span>
                            <span className="handPointer" onClick={() => this.setState({salesOrderFilters: 'partial'})}><strong>Parciales</strong></span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-danger">{this.props.salesOrders.count(order => order.get('status') === 'pending')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'pending'})}>Pendientes</span>
                        </div>
                    </div>
                );
                tableData = this.props.salesOrders.filter(salesOrder => salesOrder.get('status') === 'partial');
                break;
            case 'pending':
                statsZone = (
                    <div className="row stats-zone" style={{marginBottom: 20}}>
                        <div className="col-auto">
                            <span className="label ">{numeral(totalOrders).format()}</span>
                            <span>Importe Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{this.props.salesOrders.size || 0}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: ''})}>Pedidos</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-primary">{this.props.salesOrders.count(order => order.get('status') === 'sent')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'sent'})}>Enviados</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning">{this.props.salesOrders.count(order => order.get('status') === 'in_progress')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'in_progress'})}>En proceso</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-warning-light">{this.props.salesOrders.count(order => order.get('status') === 'partial')}</span>
                            <span className="handPointer"
                                  onClick={() => this.setState({salesOrderFilters: 'partial'})}>Parciales</span>
                        </div>
                        <div className="col-auto">
                            <span
                                className="label label-danger"><strong>{this.props.salesOrders.count(order => order.get('status') === 'pending')}</strong></span>
                            <span className="handPointer" onClick={() => this.setState({salesOrderFilters: 'pending'})}><strong>Pendientes</strong></span>
                        </div>
                    </div>
                );
                tableData = this.props.salesOrders.filter(salesOrder => salesOrder.get('status') === 'pending');
                break;
            default:
                break;
        }

        // SalesOrders Table
        let tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            order_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'order_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/ventas/pedidos/' + value[0] }>{ value[1] }</Link>
                }
            },
            document_date: {
                title: "Fecha",
                columnType: 'date',
                dataField: 'document_date',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            expected_delivery_date: {
                title: "Fecha prevista de entrega",
                columnType: 'date',
                dataField: 'expected_delivery_date',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            customer: {
                title: "Cliente",
                columnType: 'text',
                dataField: 'customer',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            subtotal: {
                title: "Subtotal",
                columnType: 'number',
                dataField: 'statistics.subtotal',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            vat: {
                title: "IVA",
                columnType: 'number',
                dataField: 'statistics.vat',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            total: {
                title: "Total",
                columnType: 'number',
                dataField: 'statistics.total',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (status) => {
                    let data = { badgeColor: '', value: '' };

                    switch (status) {
                        case 'pending':
                            data.badgeColor = 'danger';
                            data.value = 'Pendiente';
                            break;
                        case 'in_progress':
                            data.badgeColor = 'warning';
                            data.value = 'En Proceso';
                            break;
                        case 'partial':
                            data.badgeColor = 'warning-light';
                            data.value = 'Parcial';
                            break;
                        case 'sent':
                            data.badgeColor = 'primary';
                            data.value = 'Enviado';
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {data.value}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: ['_id', 'status'],
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    let popoverContent = (<Menu></Menu>);

                    switch (value[1]) {
                        case 'pending':
                            popoverContent = (
                                <Menu>
                                    <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/ventas/pedidos/' + value[0])} />
                                    <MenuItem icon="swap" text="En proceso" onClick={ () => this.props.changeSalesOrderStatus(value[0], 'in_progress', queryOptions) } />
                                    <MenuItem icon="swap" text="Parcial" onClick={ () => this.props.changeSalesOrderStatus(value[0], 'partial', queryOptions) } />
                                    <MenuItem icon="swap" text="Enviado" onClick={ () => this.props.changeSalesOrderStatus(value[0], 'sent', queryOptions) } />
                                </Menu>
                            );
                            break;
                        case 'in_progress':
                            popoverContent = (
                                <Menu>
                                    <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/ventas/pedidos/' + value[0])} />
                                    <MenuItem icon="swap" text="Pendiente" onClick={ () => this.props.changeSalesOrderStatus(value[0], 'pending', queryOptions) } />
                                    <MenuItem icon="swap" text="Parcial" onClick={ () => this.props.changeSalesOrderStatus(value[0], 'partial', queryOptions) } />
                                    <MenuItem icon="swap" text="Enviado" onClick={ () => this.props.changeSalesOrderStatus(value[0], 'sent', queryOptions) } />
                                </Menu>
                            );
                            break;
                        case 'partial':
                            popoverContent = (
                                <Menu>
                                    <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/ventas/pedidos/' + value[0])} />
                                    <MenuItem icon="swap" text="Pendiente" onClick={ () => this.props.changeSalesOrderStatus(value[0], 'pending', queryOptions) } />
                                    <MenuItem icon="swap" text="En proceso" onClick={ () => this.props.changeSalesOrderStatus(value[0], 'in_progress', queryOptions) } />
                                    <MenuItem icon="swap" text="Enviado" onClick={ () => this.props.changeSalesOrderStatus(value[0], 'sent', queryOptions) } />
                                </Menu>
                            );
                            break;
                        case 'sent':
                            popoverContent = (
                                <Menu>
                                    <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/ventas/pedidos/' + value[0])} />
                                    <MenuItem icon="swap" text="Pendiente" onClick={ () => this.props.changeSalesOrderStatus(value[0], 'pending', queryOptions) } />
                                    <MenuItem icon="swap" text="En proceso" onClick={ () => this.props.changeSalesOrderStatus(value[0], 'in_progress', queryOptions) } />
                                    <MenuItem icon="swap" text="Parcial" onClick={ () => this.props.changeSalesOrderStatus(value[0], 'partial', queryOptions) } />
                                </Menu>
                            );
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Pedidos</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => this.props.history.push('/ventas/pedidos/nuevo') } > <Icon icon="insert"/>Pedido</button>
                        </div>
                        <div className="title-action">
                            <Select
                                style={{ width: 75, marginLeft: 20 }}
                                options={yearOptions.toJS()}
                                value={this.state.selectedYear}
                                labelKey='year'
                                valueKey='year'
                                matchProp='year'
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(selectedValue) => { if (selectedValue) this.onChangeYear(selectedValue.year) }}
                            />
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    { statsZone }
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    {salesOrdersIsFetching ? (
                                        <Loading show={salesOrdersIsFetching} />
                                    ) : (
                                        <VirtualizedTable
                                            tableSettings={tableSettings}
                                            tableColumns={tableColumns}
                                            tableData={tableData}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const yearsReducer = state.years;
    const salesOrdersReducer = state.salesOrders;

    // Years
    let years = yearsReducer.get('payload') || List([]);

    if (!(years instanceof List)) {
        years = List([])
    }

    // SalesOrders
    let salesOrders = salesOrdersReducer.get('payload') || List([]);
    const salesOrdersIsFetching = salesOrdersReducer.get('isFetching');

    if (!(salesOrders instanceof List)) {
        salesOrders = List([])
    }

    return {
        years,
        salesOrders,
        salesOrdersIsFetching
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getYears: () => dispatch(getYears()),
        getSalesOrders: (query) => dispatch(getSalesOrders(query)),
        changeSalesOrderStatus: (salesOrderId, status, options) => dispatch(changeSalesOrderStatus(salesOrderId, status, options)),
        cleanYears: () => dispatch(cleanYears()),
        cleanSalesOrders: () => dispatch(cleanSalesOrders())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesOrdersPage);


// WEBPACK FOOTER //
// ./src/containers/sales/orders/SalesOrdersPage.js